var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleDriveicon = function SvgGoogleDriveicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-drive_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 11.956c0-3.485 0-5.228.678-6.559a6.222 6.222 0 0 1 2.72-2.719C7.227 2 8.97 2 12.455 2h8.088c3.485 0 5.228 0 6.559.678a6.222 6.222 0 0 1 2.719 2.72c.678 1.33.678 3.073.678 6.558v8.088c0 3.485 0 5.228-.678 6.559a6.222 6.222 0 0 1-2.72 2.719C25.773 30 24.03 30 20.545 30h-8.088c-3.485 0-5.228 0-6.559-.678a6.222 6.222 0 0 1-2.719-2.72C2.5 25.273 2.5 23.53 2.5 20.045v-8.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M16.502 12.45 13.04 6.344c.115-.117.247-.194.38-.245-1.021.336-1.49 1.482-1.49 1.482L5.61 18.735c-.089.35-.114.665-.103.943h6.901l4.095-7.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "m16.502 12.45 4.095 7.228h6.9a3.276 3.276 0 0 0-.102-.943L21.072 7.58s-.47-1.146-1.488-1.482c.13.051.264.128.379.245l-3.461 6.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "m16.502 12.451 3.46-6.108a1.08 1.08 0 0 0-.378-.245 1.87 1.87 0 0 0-.489-.09h-5.187c-.174.007-.337.04-.488.09a1.08 1.08 0 0 0-.379.245l3.46 6.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "m12.408 19.678-3.421 6.039s-.114-.055-.268-.17c.485.374.957.453.957.453h13.437c.742 0 .896-.283.896-.283l.006-.004-3.419-6.035h-8.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M12.409 19.678H5.508c.034.82.39 1.3.39 1.3l.26.45c.018.027.03.042.03.042l.564.991 1.268 2.207c.037.089.08.17.126.249.017.026.033.055.052.08l.015.023c.156.221.332.392.507.527.155.116.268.17.268.17l3.42-6.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M20.597 19.678h6.9c-.034.82-.39 1.3-.39 1.3l-.26.45c-.018.027-.03.042-.03.042l-.564.991-1.268 2.207c-.037.089-.08.17-.125.249-.018.026-.034.055-.052.08l-.015.023a2.433 2.433 0 0 1-.508.527c-.154.116-.268.17-.268.17l-3.42-6.039z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "google-drive_icon_svg__a",
    width: 36,
    height: 36,
    x: -1.5,
    y: -1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_5761"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_25_5761",
    result: "shape"
  })))));
};
export default SvgGoogleDriveicon;